import { ChangeDetectorRef, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { LaasOption } from 'src/app/core/models/laas-option';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { AutoPrintSettingTableHeaderData } from './interface/auto-print-setting-header-data';
import { AutoPrintSettingTableDetailData } from './interface/auto-print-setting-detail-data';
import { AutoPrintSettingService } from '../../service/auto-print-setting.service';
import { finalize } from 'rxjs/operators';
import { AutoPrintSettingGetHeaderRequest } from './interface/auto-print-setting-get-header-request';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { throwError } from 'rxjs';
import { AutoPrintSettingGetDetailRequest } from './interface/auto-print-setting-get-detail-request';
import { MenuItem } from 'primeng/api';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationSubScriptionService } from 'src/app/core/services/notification-sub-scription.service';
import { MultiSelect } from 'primeng/multiselect';
import { FacilityService } from 'src/app/core/services/facility.service';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';

@Component({
  selector: 'laas-auto-print-setting',
  templateUrl: './auto-print-setting.component.html',
  styleUrls: ['./auto-print-setting.component.scss'],
})
export class AutoPrintSettingComponent extends SessionBaseComponent implements OnInit {
  readonly viewPermissionCode = PermissionConstants.ViewAutoPrintSetting;
  currentLang: string = this.laasSetting.language;
  facilityOptions: FacilityOptions[] = [];

  constructor(
    private injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
  ) {
    super(injector);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    this.initFacilityOption();
  }

  initFacilityOption() {
    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options;
        if (this.userProfile.userType == UserType.Shipping.toString()) {
          var newOptions = deepCopy(options.filter((x: any) => {
            return this.dataScope.facilityCodes.includes(x.optionCode);
          })) as any[];
          this.facilityOptions = newOptions;
        } else {
          this.facilityOptions = options;
        }
      },
    });
  }

}
